
import React, { useContext, useEffect, useState } from "react";
import CircularScrollProgress from "../Circularprogress";
import { useNavigate } from "react-router-dom";
import AuthUser from "../../services/AuthUser";
import { handleRazorpayPayment } from "../../services/handlePayment";
import { ServicesContext } from "../../services/ServicesContext";
import CitySelector from "../User/CitySelectore";
import WhatsAppScrollButton from "../floatingwhatsApp";
import Footer from "../footer";
import { PartenerSheepDeedService } from "../../services/parternshipservice";
import HomeCounters from "../Homecounters";
import Testimonials from "../Testimonial";


function PfAndEsicRegistration() {

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      const parsedUser = JSON.parse(storedUser);
      setNewData((prevData) => ({
        ...prevData,
        user_name: parsedUser.name || "",
        user_email: parsedUser.email || "",
        user_contact: parsedUser.mobile || "",
        user_city: parsedUser.city || "",

      }));
    }
  }, []);


  const [activeQuestion, setActiveQuestion] = useState(null);
  const { http, token } = AuthUser();
  const navigate = useNavigate();
  const toggleQuestion = (questionId) => {
    setActiveQuestion((prev) => (prev === questionId ? null : questionId));
  };


  const [newData, setNewData] = useState({ user_name: '', user_email: '', user_contact: '', user_category: '' })

  const [errors, setErrors] = useState({});

  const { services, loading, error } = useContext(ServicesContext);

  const service = services.find(s => s.service_id === 50);

  const validateForm = () => {
    const newErrors = {};

    // Name validation
    if (!newData.user_name.trim()) {
      newErrors.user_name = 'Name is required.';
    } else if (!/^[a-zA-Z\s]+$/.test(newData.user_name)) {
      newErrors.user_name = '*Name should only contain letters and spaces.';
    }

    // Email validation
    if (!newData.user_email.trim()) {
      newErrors.user_email = 'Email is required.';
    } else if (!/\S+@\S+\.\S+/.test(newData.user_email)) {
      newErrors.user_email = 'Enter a valid email address.';
    }

    // Phone number validation
    // if (newData.user_contact && !/^\d{10}$/.test(newData.user_contact)) {
    //    newErrors.user_contact = 'Enter a valid 10-digit contact number.';
    // }

    if (!newData.user_contact.trim()) {
      newErrors.user_contact = 'number is required.';
    } else if (!/^\d{10}$/.test(newData.user_contact)) {
      newErrors.user_contact = 'Enter a valid 10-digit contact number.';
    }

    // Category validation
    if (!newData.user_category) {
      newErrors.user_category = 'Please select a category.';
    }

    // City validation
    if (!newData.user_city) {
      newErrors.user_city = 'City/District is required.';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Return true if no errors
  };



  const formPutPartenshipdeed = async (e) => {
    e.preventDefault();
    // ✅ Check if user is logged in
    // if (!token) {
    //   alert("Please log in to continue.");
    //   localStorage.setItem("redirectAfterLogin", window.location.pathname); // ⬅️ Save current path
    //   navigate('/login'); // 👈 Use this if you're using React Router
    //   return;
    // }
    if (!validateForm()) return;

     localStorage.setItem("bookingData", JSON.stringify(newData));

      // Navigate to checkout
      navigate('/checkout', {
         state: {
            service: service,

         }
      });

       // ✅ RESET FORM (SAFE)
  setNewData({
    user_name: '',
    user_email: '',
    user_contact: '',
    user_city: ''
  });

  };


  
      //   const formPutPartenshipdeed = async (e) => {
      //     e.preventDefault();
      
      //     if (!validateForm()) return;
      
      //     try {
      //         const response = await PartenerSheepDeedService.pfAndEsicRegistration(newData);
      
      //         console.log("API Success:", response);
      
      //         navigate("/thankyou");
      
      //         // Optional: reset form
//              setNewData(prev => {
//   const resetObj = {};
//   Object.keys(prev).forEach(key => (resetObj[key] = ""));
//   return resetObj;
// });
    
      
      //     } catch (error) {
      //         console.error("API Error:", error);
      //         alert("Something went wrong!");
      //     }
      // };

  const faqs = [
    {
      question: "Is ESIC registration mandatory for all businesses?",
      answer: "ESIC registration is mandatory for establishments with 10 or more employees (20 in some states) earning wages below the prescribed limit."
    },
    {
      question: "When is PF registration required?",
      answer: "PF registration is compulsory for businesses employing 20 or more workers."
    },
    {
      question: "Can I register for ESIC and PF online?",
      answer: "Yes, both ESIC and PF registrations can be completed online through the respective official portals with the help of our professionals."
    },
    {
      question: "What benefits do employees get under ESIC?",
      answer: "Employees receive medical, sickness, maternity, disability, and dependent benefits under ESIC."
    },
    {
      question: "What is the employer’s contribution rate for PF?",
      answer: "Typically, the employer contributes 12% of the employee's basic wages towards PF, subject to statutory norms."
    },
    {
      question: "How long does the registration process take?",
      answer: "The registration process usually takes 7 to 15 working days, depending on the completeness of documents and government processing times."
    },
    {
      question: "Are there penalties for non-registration?",
      answer: "Yes, failure to register can lead to heavy fines, legal actions, and penalties under labor laws."
    },
    {
      question: "Can I add new employees after registration?",
      answer: "Yes, you can add new employees by updating your records with ESIC and PF authorities regularly."
    },
    {
      question: "Do I need a Digital Signature Certificate for PF registration?",
      answer: "A DSC is required for online filings and submissions if applicable in your state or organization type."
    },
    {
      question: "What support do you offer after registration?",
      answer: "We assist with monthly contribution filings, annual returns, and compliance management to keep your business up to date."
    }
  ];


  const handleBannerClick = () => {
  const formElement = document.querySelector(".contact3-form-all");

  if (formElement) {
    formElement.classList.add("shake-effect");

    // remove effect after animation finishes
    setTimeout(() => {
      formElement.classList.remove("shake-effect");
    }, 400); // same as animation duration
  }
};


  return (
    <div>


      <div className="hero-area10 header-background">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="title title2 ">
                <div className="headding-shape aniamtion-key-2">
                  <img src="assets/img/shapes/hero8-shape2.svg" alt="" />
                </div>
                <h1 className="sk-text-color">ESIC & PF Registration for Your Business</h1>
                <p className="pdrl-text">Get PF & ESIC Registration Services for only <span className="text-color"> Rs.{service?.price}/- </span> <span>(Final Price, No Hidden Costs)</span></p>
                <p className="pd-text">Running a business comes with important responsibilities toward your employees’ welfare and compliance with government regulations. Two essential registrations for organizations in India are ESIC (Employees’ State Insurance Corporation) Registration and PF (Provident Fund) Registration. Both schemes offer vital social security benefits to employees while ensuring your company adheres to statutory labor laws.</p>
                {/* <p className="pd-text">It is issued by the DGFT (Director General of Foreign Trade). This PAN-based registration with the DGFT remains valid until it is surrendered or canceled.</p> */}
                               <div className="banner" onClick={handleBannerClick}>
   <img src="assets/icons/banner.svg" alt="" />
</div>
              </div>
            </div>
            <div className="col-lg-4">
              <img className="hero9-shape3 aniamtion-key-1" src="assets/img/shapes/hero9-shape.svg" alt="" />
              <div className="contact3-form-all">
                <div className="hadding7">
                  <h3>Book Service Now </h3>
                  <p className="pdrl-text">at Rs.{service?.price}/- Only <br /> <span>(Final Price, No Hidden Costs)</span></p>
                </div>
                <form action="#">
                  <div className="form-input-all">
                    <div className="form-input-box">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="input-single6">
                            <div className="">
                              <label for="">Name<span className="red">*</span></label> {errors.user_name && <p className="error-text">{errors.user_name}</p>}
                              <input type="text" placeholder="Enter your Name" value={newData.user_name} onChange={(e) => setNewData({ ...newData, user_name: e.target.value })} />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="input-single6">
                            <div className="">
                              <label for="">Email Address<span className="red">*</span></label> {errors.user_email && <p className="error-text">{errors.user_email}</p>}
                              <input type="email" placeholder="Enter your Email Address" value={newData.user_email} onChange={(e) => setNewData({ ...newData, user_email: e.target.value })} />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="input-single6">
                            <div className="">
                              <label for="">Contact Number<span className="red">*</span></label> {errors.user_contact && <p className="error-text">{errors.user_contact}</p>}
                              <input type="number" placeholder="Enter your Contact Number" value={newData.user_contact} onChange={(e) => setNewData({ ...newData, user_contact: e.target.value })} />
                            </div>
                          </div>
                        </div>

                        <div className="col-12">
                          <CitySelector
                            newData={newData}
                            setNewData={setNewData}
                            fieldKey="user_city"
                            errors={errors}
                          />
                        </div>
                        <div className="col-12">
                          <label for="" className="dropdown-text">Category<span className="red">*</span></label> {errors.user_category && <p className="error-text">{errors.user_category}</p>}
                          <div className="niceSelect">
                            <select className="wide" onChange={(e) => setNewData({ ...newData, user_category: e.target.value })} value={newData.user_category}>
                              <option className="formop" data-display="Select Category...">Select Category...</option>
                              <option value="Sole Proprietorship / Individual">Sole Proprietorship / Individual</option>
                              <option value="Partnership / LLP">Partnership / LLP</option>
                              <option value="Private limited / Public limited / One person company">Private limited / Public limited / One person company</option>
                              <option value="HUF">HUF</option>
                              <option value="Society / Trust / Club">Society / Trust / Club</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="space20"></div>
                    <div className="btn-group-2">
                      <a className="theme-btn-3" href="#" onClick={formPutPartenshipdeed}>Proceed now <span><i className="fa-solid fa-arrow-right"></i></span></a>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="space60 bg-white"></div>

      <div className="home4-counters bg-white">
        <div className="container">

          <div className="row">
            <div className="col-md-12">


              <HomeCounters />
            </div>
          </div>


          <div className="space40"></div>
          <div className="row">
            <div className="col-lg-12">
              <p className="pd-text">What is ESIC Registration?
                ESIC Registration is mandatory for establishments with 10 or more employees earning wages up to ₹21,000 per month. This scheme provides comprehensive health insurance and social security benefits covering medical care, sickness, maternity, disability, and dependents' benefits. It’s designed to safeguard workers and their families from financial distress arising from illness, injury, or loss of employment.

                Registering under ESIC allows your employees to avail medical facilities through ESIC dispensaries and hospitals and gain access to various benefits, promoting workforce welfare and productivity.</p>
              <p className="pd-text">What is PF Registration?
                PF Registration is compulsory for companies with 20 or more employees. It ensures financial security for employees by mandating contributions to the Employees’ Provident Fund, a long-term savings scheme that supports employees during retirement, unemployment, or emergencies.

                Both the employer and employee contribute a fixed percentage of wages monthly to the fund, which accumulates with interest over time. Apart from retirement benefits, PF also covers pension and insurance schemes under the Employees’ Pension Scheme (EPS) and Employees’ Deposit Linked Insurance Scheme (EDLI).
              </p>
            </div>
          </div>
          <div className="space20"></div>

        </div>
      </div>



      <div className="service-binifits9 bg-white" >
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="hadding7">
                <div className="space40"></div>
                <h2 className="text-center">How to apply</h2>
                <div className="space20"></div>
                <img src="assets/img/images/Import-Export-License-(IEC).png" />
              </div>
              <div className="space20"></div>
            </div>
          </div>
        </div>
      </div>
      <div className="space20 bg-white"></div>

      <div className="last-section bg-white">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="hadding7">

                <h2 className="text-center">Documents Required for Registration </h2>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="hadding7">
                <div className="space40"></div>
                <p>For ESIC Registration, the following documents are required:</p>
                <div className="contact6-list">
                  <ul>
                    <li className="font-f-7">
                      <span><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>
                      Business PAN Card
                    </li>
                    <li className="font-f-7">
                      <span><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>
                      Certificate of Incorporation or Business Registration
                    </li>
                    <li className="font-f-7">
                      <span><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>
                      Address Proof of the Establishment (utility bill, rent agreement)
                    </li>
                    <li className="font-f-7">
                      <span><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>
                      List of Employees with details (name, DOB, gender, wages)
                    </li>
                    <li className="font-f-7">
                      <span><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>
                      Identity Proof of Employees (Aadhaar card, voter ID)
                    </li>
                    <li className="font-f-7">
                      <span><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>
                      Bank Account Details of the Establishment
                    </li>
                    <li className="font-f-7">
                      <span><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>
                      Authorized Signatory Details (ID proof and photograph)
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="hadding7">
                <div className="space40"></div>
                <p>For PF Registration, the following documents are required:</p>
                <div className="contact6-list">
                  <ul>
                    <li className="font-f-7">
                      <span><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>
                      Business PAN Card
                    </li>
                    <li className="font-f-7">
                      <span><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>
                      Certificate of Incorporation or Partnership Deed/LLP Agreement
                    </li>
                    <li className="font-f-7">
                      <span><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>
                      Address Proof of the Business
                    </li>
                    <li className="font-f-7">
                      <span><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>
                      List of Employees with Salary Details (wages, joining date)
                    </li>
                    <li className="font-f-7">
                      <span><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>
                      Bank Account Details of the Employer
                    </li>
                    <li className="font-f-7">
                      <span><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>
                      Details of Directors/Partners with ID Proof
                    </li>
                    <li className="font-f-7">
                      <span><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>
                      Digital Signature Certificate (DSC) of the authorized signatory (if applicable)
                    </li>
                  </ul>
                </div>
              </div>
            </div>

          </div>


          <div className="space20"></div>
        </div>
      </div>



      <div className="bg-white">

        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="hadding7">
                <div className="space40"></div>
                <h2 className="text-center">Common Mistakes to Avoid in ESIC and PF registration</h2>
                <div className="space20"></div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="contact6-list doc-list">
                <ul>
                  <li className="font-f-7">
                    <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                    Not following the Rules and Regulations
                  </li>
                  <li className="font-f-7">
                    <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                    Not Submitting Accurate Information
                  </li>
                  <li className="font-f-7">
                    <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                    Not Meeting Deadlines
                  </li>
                  <li className="font-f-7">
                    <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                    Not Keeping Copies of Documents
                  </li>
                  <li className="font-f-7">
                    <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                    Not Paying Attention To Details
                  </li>
                  <li className="font-f-7">
                    <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                    Providing Inaccurate Employee Information
                  </li>
                </ul>

              </div>
            </div>
            <div className="col-lg-4">
              <div className="contact6-list doc-list">
                <img src="assets/img/images/Common-Mistakes-to-Avoid-in-IEC-Registration.png" alt="" />
              </div>
            </div>

            <div className="col-lg-4">
              <div className="contact6-list doc-list">
                <ul>

                  <li className="font-f-7">
                    <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                    Delaying Registration After Business Setup
                  </li>
                  <li className="font-f-7">
                    <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                    Failing to Update Employee Records Regularly
                  </li>
                  <li className="font-f-7">
                    <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                    Not Maintaining Proper Salary Details
                  </li>
                  <li className="font-f-7">
                    <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                    Ignoring Digital Signature Requirements
                  </li>
                  <li className="font-f-7">
                    <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                    Submitting Incomplete Application Forms
                  </li>
                  <li className="font-f-7">
                    <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                    Not Consulting Professionals for Complex Queries
                  </li>
                </ul>
              </div>
            </div>

          </div>

          <div className="row">
            <div className="col-lg-12">
              <div className="hadding7">
                <div className="space40"></div>
                <h2 className="text-center">Benefits of Online ESIC and PF Registration with Dm2Legal</h2>
              </div>
            </div>
            <div className="space30"></div>
          </div>
          <div className="row">
            <div className="col-md-4 col-lg-3 col-sm-6">
              <div className="single-service text-center">
                <div className="service-icon bg-24">
                  <img src="assets/img/icons/service-9.png" alt="" />
                </div>
                <h3>Financial Security for Employees</h3>
              </div>
            </div>
            <div className="col-md-4 col-lg-3 col-sm-6">
              <div className="single-service text-center">
                <div className="service-icon bg-24">
                  <img src="assets/img/icons/service-10.png" alt="" />
                </div>
                <h3>Access to Medical and Disability Benefits</h3>
              </div>
            </div>
            <div className="col-md-4 col-lg-3 col-sm-6">
              <div className="single-service text-center">
                <div className="service-icon bg-24">
                  <img src="assets/img/icons/service-16.png" alt="" />
                </div>
                <h3>Maternity Benefits Under ESIC</h3>
              </div>
            </div>
            <div className="col-md-4 col-lg-3 col-sm-6">
              <div className="single-service text-center">
                <div className="service-icon bg-24">
                  <img src="assets/img/icons/service-12.png" alt="" />
                </div>
                <h3>Retirement and Pension Benefits</h3>
              </div>
            </div>
            <div className="col-md-4 col-lg-3 col-sm-6">
              <div className="single-service text-center">
                <div className="service-icon bg-24">
                  <img src="assets/img/icons/service-13.png" alt="" />
                </div>
                <h3>Tax Benefits for Employers</h3>
              </div>
            </div>
            <div className="col-md-4 col-lg-3 col-sm-6">
              <div className="single-service text-center">
                <div className="service-icon bg-24">
                  <img src="assets/img/icons/service-14.png" alt="" />
                </div>
                <h3>Boosts Employee Morale</h3>
              </div>
            </div>
            <div className="col-md-4 col-lg-3 col-sm-6">
              <div className="single-service text-center">
                <div className="service-icon bg-24">
                  <img src="assets/img/icons/service-15.png" alt="" />
                </div>
                <h3>Ensures Legal Compliance</h3>
              </div>
            </div>
            <div className="col-md-4 col-lg-3 col-sm-6">
              <div className="single-service text-center">
                <div className="service-icon bg-24">
                  <img src="assets/img/icons/service-11.png" alt="" />
                </div>
                <h3>Access to Loans via PF</h3>
              </div>
            </div>
            <div className="col-md-4 col-lg-3 col-sm-6">
              <div className="single-service text-center">
                <div className="service-icon bg-24">
                  <img src="assets/img/icons/service-16.png" alt="" />
                </div>
                <h3>Unemployment Support via ESIC</h3>
              </div>
            </div>

            {/* <div className="col-md-4 col-lg-3 col-sm-6">
                     <div className="single-service text-center">
                        <div className="service-icon bg-24">
                           <img src="assets/img/icons/service-16.png" alt="" />
                        </div>
                        <h3>Compete with or beat local players</h3>
                     </div>
                  </div> */}
            {/* <div className="col-md-4 col-lg-3 col-sm-6">
                     <div className="single-service text-center">
                        <div className="service-icon bg-24">
                           <img src="assets/img/icons/service-11.png" alt="" />
                        </div>
                        <h3>Requirement of Simple Documents</h3>
                     </div>
                  </div> */}
          </div>



        </div>
      </div>


      <div className="service-binifits9 sp0" id="service2">
        <div className="container work8">
          <div className="row">
            <div className="col-lg-12 text-center">
              <div className="hadding7">
                <div className="space80"></div>
                <h2>Process of Registration </h2>
              </div>
              <div className="partnership-deade-section">
                <div className="space40"></div>

                <ul className="disc-list">
                  <li> <h3>Step 1 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                    <span>Document Verification: We review all required business and employee documents to ensure completeness and accuracy.</span>
                    <svg className="pointer">
                      <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                    </svg>
                  </li>
                  <li><h3>Step 2 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                    <span>Application Preparation: Draft and submit the application along with supporting documents to the respective authorities.</span>
                    <svg className="pointer">
                      <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                    </svg>
                  </li>
                  <li><h3>Step 3 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                    <span>Follow-Up: Monitor the application status and respond promptly to any queries or additional requirements.</span>
                    <svg className="pointer">
                      <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                    </svg>
                  </li>
                  <li><h3>Step 4 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                    <span>Certificate Issuance: Receive your official ESIC and PF registration certificates to start contributing legally.</span>
                    <svg className="pointer">
                      <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                    </svg>
                  </li>
                  <li>
                    <h3>Step 5 <span><img className="arow" src="assets/image/done.svg" alt="" /></span></h3>
                    <span>Post-Registration Compliance: Guidance on monthly contribution filing, record maintenance, and periodic reporting.</span>
                    <svg className="pointer">
                      <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                    </svg>
                  </li>
                </ul>

                <div className="space80"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="space40 bg-white"></div>
      <div className="bg-white">

        <div className="container ">
          <div className="row">
            <div className="col-lg-12">
              <div className="hadding7">
                <h2 className="text-center">Online ESIC and PF Registration: Step-by-Step Guide</h2>
              </div>
            </div>
            <div className="col-lg-8">
              <div className="hadding7">
                <div className="space20"></div>
                <div className="contact6-list">
                  <ul>
                    <li className="font-f-7 step-font-size">
                      <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Step 1:
                      <p className="pd-text">Visit the official ESIC or EPFO registration portal and create an account using your business email.</p>
                    </li>
                    <hr />
                    <li className="font-f-7 step-font-size">
                      <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Step 2:
                      <p className="pd-text">Fill in all required business information including PAN, address, and business type.</p>
                    </li>
                    <hr />
                    <li className="font-f-7 step-font-size">
                      <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Step 3:
                      <p className="pd-text">Provide employee details like name, gender, DOB, salary, and date of joining.</p>
                    </li>
                    <hr />
                    <li className="font-f-7 step-font-size">
                      <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Step 4:
                      <p className="pd-text">Upload all necessary documents such as incorporation certificate, address proof, and employee ID proof.</p>
                    </li>
                    <hr />
                    <li className="font-f-7 step-font-size">
                      <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Step 5:
                      <p className="pd-text">Submit the application online using your Digital Signature Certificate (DSC), if required.</p>
                    </li>
                    <hr />
                    <li className="font-f-7 step-font-size">
                      <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Step 6:
                      <p className="pd-text">Once approved by the department, receive your ESIC or PF Registration Number on your email.</p>
                    </li>
                  </ul>

                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="space30"></div>
              <img src="assets/img/images/Online-IEC-Code-Registration-Step-by-Step-Guide.png" alt="" />
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="faq-items" id="masonry-grid">
                <div className="mesonry-item general single-price-list">
                  <div className="faqs inner-faq">
                    <h2 className="text-center">FAQs on Import Export License </h2>
                    <div className="space20"></div>


                    <div id="general">
                      {faqs.map((faq, index) => (
                        <div className="single-faq" key={index}>
                          <h2
                            className={`faq-heading font-f-3 weight-700 ${activeQuestion === index ? '' : 'collapsed'}`}
                            id={`faq-heading${index}`}
                            onClick={() => toggleQuestion(index)}
                          >
                            Q{index + 1}: {faq.question}
                            <span>
                              {activeQuestion === index ? (
                                <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="collapse icon" />
                              ) : (
                                <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="expand icon" />
                              )}
                            </span>
                          </h2>
                          <div
                            id={`collapse${index}`}
                            className={`accordion-collapse collapse ${activeQuestion === index ? 'show' : ''}`}
                          >
                            <p className="font-f-3 weight-500">{faq.answer}</p>
                          </div>
                        </div>
                      ))}







                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <Testimonials />



      <div className="last-section bg-white">
        <div className="container">
          <div className="row">
            <div className="col-lg-7 m-auto text-center">
              <div className="hadding7">
                <div className="space20"></div>
                <h2 className="aos-init aos-animate">Why Choose Us?</h2>
              </div>
            </div>
          </div>
          <div className="space30"></div>
          <div className="row">
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>1</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/growth.svg" alt="" /></span><a href="single-service-1.html" >Growth & Improvement</a></h4>
                  <p>We are committed to continuous growth and improvement. To us, growth is the fundamental principle of life, and we strive to achieve it. We understand the significance of business growth and its importance to you.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>2</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/support.svg" alt="" /></span><a href="single-service-1.html" >Support & Availability</a></h4>
                  <p>We understand how even a small problem or query can cause frustration. That's why we are always available to provide support and resolve any issues you may have, whenever they arise.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>3</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/team.svg" alt="" /></span><a href="single-service-1.html" >Experienced Team</a></h4>
                  <p>Our team consists of experienced professionals who prioritize professionalism and customer satisfaction above all else. Each member is passionate about their respective field and dedicated to delivering the best service.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>4</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/focus.svg" alt="" /></span><a href="single-service-1.html" >Focus</a></h4>
                  <p>We treat every task with the utmost importance. Our team members remain dedicated and focused on addressing even the smallest needs and requirements of our clients.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>5</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/value.svg" alt="" /></span><a href="single-service-1.html" >Value for Money</a></h4>
                  <p>We understand the value of your hard-earned money. That's why we ensure that every penny you invest with us is utilized in the most effective way, delivering the best value for your investment.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>6</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/care.svg" alt="" /></span><a href="single-service-1.html" >Care & Regards</a></h4>
                  <p>We consider you a part of our family, and your challenges and successes are our own. Your interests are our priority, and we are dedicated to fulfilling them with the utmost care and attention.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="space40 bg-white"></div>


      <WhatsAppScrollButton />
      <Footer />
      <CircularScrollProgress />
    </div>

  );
}
export default PfAndEsicRegistration;